// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z-gQC","fullView":"styles_fullView__3zBMK"};